import { faArrowDown, faArrowUp, faCircleInfo } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { TableCell, Tooltip, useTheme } from "@mui/material"
import { flexRender } from "@tanstack/react-table"
import React from "react"

interface TableHeaderProps {
  header: any
  setSort?: (sort: { id: string; desc: boolean } | null) => void
  currentSort?: { id: string; desc: boolean } | null
}

const TableHeader: React.FC<TableHeaderProps> = ({ header, setSort, currentSort }) => {
  const theme = useTheme()

  const handleClick = (e: React.MouseEvent) => {
    if (setSort) {
      // Server-side tri-state sorting
      if (!currentSort || currentSort.id !== header.column.id) {
        setSort({ id: header.column.id, desc: false }) // none → asc
      } else if (!currentSort.desc) {
        setSort({ id: header.column.id, desc: true }) // asc → desc
      } else {
        setSort(null) // desc → none
      }
    } else {
      // Client-side: use React Table toggle handler
      const toggleHandler = header.column.getToggleSortingHandler?.()
      if (toggleHandler) toggleHandler(e)
    }
  }

  let sortIcon = null

  if (setSort) {
    // Server-side
    if (currentSort && currentSort.id === header.column.id) {
      sortIcon = currentSort.desc ? (
        <FontAwesomeIcon style={{ marginLeft: 6 }} icon={faArrowDown} />
      ) : (
        <FontAwesomeIcon style={{ marginLeft: 6 }} icon={faArrowUp} />
      )
    }
  } else {
    // Client-side
    const isSorted = header.column.getIsSorted?.()
    if (isSorted === "asc") {
      sortIcon = <FontAwesomeIcon style={{ marginLeft: 6 }} icon={faArrowUp} />
    } else if (isSorted === "desc") {
      sortIcon = <FontAwesomeIcon style={{ marginLeft: 6 }} icon={faArrowDown} />
    }
  }

  const width = header.column.columnDef.size || header.column.columnDef.meta?.width
  const minWidth = header.column.columnDef.minSize || header.column.columnDef.meta?.minWidth

  return (
    <TableCell
      onClick={handleClick}
      className="d-flex align-items-center w-100 mb-2"
      style={{
        cursor: "pointer",
        width: width,
        minWidth: minWidth,
        whiteSpace: minWidth ? "nowrap" : undefined
      }}>
      {header.column.columnDef.header ? (
        flexRender(header.column.columnDef.header, header.getContext())
      ) : (
        <span className="mt-3"></span>
      )}
      {header.column.columnDef.meta?.tooltip && (
        <Tooltip title={header.column.columnDef.meta.tooltip}>
          <span style={{ marginLeft: 6, display: "inline-flex", alignItems: "baseline", position: "relative", top: 2 }}>
            <FontAwesomeIcon
              icon={faCircleInfo}
              color={(theme.palette as any).primary[700]}
            />
          </span>
        </Tooltip>
      )}
      {sortIcon}
    </TableCell>
  )
}

export default TableHeader
